import axios, { AxiosResponse } from "axios";
import {
	IApiHandlerParams,
	IApiMethods,
	IRequestConfig,
	TApiResponse,
	TRequestParams,
	TRequestMethods
} from "@/api/interface";
import { requestHandler, activateLoading, handleErrorResponse } from "@/api/handler";
import { API_URL } from "./config";
import "./requester-setup";
import { authEntity } from "@/models/modules/auth/entity";

const getRequestUrl = (config?: IRequestConfig): string =>
	config?.handler?.dontUseApiUrl ? "" : API_URL;

export default {

	get(endpoint: string, config?: IRequestConfig): Promise<TApiResponse> {
		return this.request(
			"get",
			[ endpoint, config?.request || {} ],
			config?.handler as any,
			config?.isFile,
			config?.fileName
		);
	},

	post(endpoint: string, body?: any, config?: IRequestConfig): Promise<TApiResponse> {
		return this.request(
			"post",
			[ endpoint, body, config?.request || {} ],
			config?.handler as any,
			config?.isFile,
			config?.fileName
		);
	},

	put(endpoint: string, body?: any, config?: IRequestConfig): Promise<TApiResponse> {
		return this.request(
			"put",
			[ endpoint, body, config?.request || {} ],
			config?.handler as any
		);
	},

	patch(endpoint: string, body?: any, config?: IRequestConfig): Promise<TApiResponse> {
		return this.request(
			"patch",
			[ endpoint, body, config?.request || {} ],
			config?.handler as any
		);
	},

	delete(endpoint: string, config?: IRequestConfig): Promise<TApiResponse> {
		return this.request(
			"delete",
			[ endpoint, config?.request || {} ],
			config?.handler as any
		);
	},

	async request(
		method: TRequestMethods,
		params: any[],
		config?: IApiHandlerParams,
		typeFile?: boolean,
		fileName?: string,
	): Promise<TApiResponse> {
		if (authEntity.customerSessionExpiredState && !config?.skipSessionExpired)
			return null;

		activateLoading(config);

		if (config) params[params.length - 1].API_HANDLER_CONFIG = config;

		params[params.length - 1].API_ENDPOINT = params[0];

		params[0] = getRequestUrl({ handler: config }) + params[0];
		
		if (typeFile) {
			params[params.length - 1] = { responseType: 'blob' };
		}

		return (axios[method].apply(axios, params as TRequestParams) as Promise<AxiosResponse<TApiResponse>>)
			.then(r => {
				if (typeFile) {
					const anchorElement = document.createElement('a');
					document.body.appendChild(anchorElement);
					anchorElement.style.display = 'none';
					const file = new Blob([r.data], {type: 'application/octet-stream'});
					
					const url = window.URL.createObjectURL(file);
					
					anchorElement.href = url;
					anchorElement.download = fileName;
					anchorElement.click();
					
					window.URL.revokeObjectURL(url);
					anchorElement.remove();
				}
				return requestHandler(r, config)
			})
			.catch(r => handleErrorResponse(config, r));
	}

} as IApiMethods
